/** Creatives carried over from the original Desi Race (old/images, old/image_main, old/slot/img). */
import bgDesk from "../../assets/desi/bg/index-bg.jpg";
import bgMob from "../../assets/desi/bg/mobbg.jpg";
import rulesBgDesk from "../../assets/desi/bg/background-web.png";

import welcomeLogoGif from "../../assets/desi/ui/welcome-logo.gif";
import welcomeLogoPng from "../../assets/desi/ui/welcome-logo.png";
import topLine from "../../assets/desi/ui/Top-line.png";
import rulesText from "../../assets/desi/ui/rules-text.png";
import thankyouGif from "../../assets/desi/ui/thankyou.gif";

import people1 from "../../assets/desi/peoples/1.png";
import people2 from "../../assets/desi/peoples/2.png";
import people3 from "../../assets/desi/peoples/3.png";
import people4 from "../../assets/desi/peoples/4.png";
import people6 from "../../assets/desi/peoples/6.png";
import people7 from "../../assets/desi/peoples/7.png";

import bengalTitle from "../../assets/desi/Bengal/bengal-title.png";
import bengalText from "../../assets/desi/Bengal/BENGAL_TEXT.png";
import bengalCharac from "../../assets/desi/Bengal/BENGAL_CHARAC.png";
import mhTitle from "../../assets/desi/MH/MH-title.png";
import mhText from "../../assets/desi/MH/MAHA_TEXT.png";
import mhCharac from "../../assets/desi/MH/Character.png";
import gujTitle from "../../assets/desi/GUJ/GUJ-title.png";
import gujText from "../../assets/desi/GUJ/GUJ_TEXT.png";
import gujCharac from "../../assets/desi/GUJ/Character.png";
import punjabTitle from "../../assets/desi/Punjab/Punjab-title.png";
import punjabText from "../../assets/desi/Punjab/Punjab_TEXT.png";
import punjabLeft from "../../assets/desi/Punjab/Pun_Charac-left.png";
import punjabRight from "../../assets/desi/Punjab/Pun_Charac-right.png";
import andhraTitle from "../../assets/desi/Andhra/Andhra-title.png";
import andhraText from "../../assets/desi/Andhra/Andhra_Text.png";
import andhraCharac from "../../assets/desi/Andhra/Andhra_Charac.png";
import karnatakaTitle from "../../assets/desi/Karnataka/Karntaka-title.png";
import karnatakaText from "../../assets/desi/Karnataka/KARNATAKA_TEXT.png";
import karnatakaCharac from "../../assets/desi/Karnataka/KARNATAKA_CHARAC.png";

import flower1 from "../../assets/desi/flowers/1.jpg";
import flower2 from "../../assets/desi/flowers/2.jpg";
import flower3 from "../../assets/desi/flowers/3.jpg";
import flower4 from "../../assets/desi/flowers/4.jpg";
import flower5 from "../../assets/desi/flowers/5.jpg";

import faral1 from "../../assets/desi/faral/1.png";
import faral2 from "../../assets/desi/faral/2.png";
import faral3 from "../../assets/desi/faral/3.png";
import faral4 from "../../assets/desi/faral/4.png";
import faral5 from "../../assets/desi/faral/5.png";
import faral6 from "../../assets/desi/faral/6.png";
import faral7 from "../../assets/desi/faral/7.png";
import faral8 from "../../assets/desi/faral/8.png";
import faral9 from "../../assets/desi/faral/9.png";

import slotMain from "../../assets/desi/slot/main.png";
import slotEnergy from "../../assets/desi/slot/energy-64.png";
import slotStaff from "../../assets/desi/slot/staff-64.png";
import slotCash from "../../assets/desi/slot/cash-64.png";
import slotBuild from "../../assets/desi/slot/build-64.png";
import slotGoods from "../../assets/desi/slot/goods-64.png";
import slotGold from "../../assets/desi/slot/gold-64.png";

export const BACKGROUNDS = {
  desk: bgDesk,
  mob: bgMob,
  rulesDesk: rulesBgDesk,
};

export const UI = {
  welcomeLogoGif,
  welcomeLogoPng,
  topLine,
  rulesText,
  thankyouGif,
};

export const PEOPLE = {
  bengal: people1,
  maharashtra: people2,
  gujarat: people3,
  punjab: people4,
  andhra: people6,
  karnataka: people7,
};

export const STATE_ART = {
  bengal: { title: bengalTitle, text: bengalText, left: null, right: bengalCharac },
  maharashtra: { title: mhTitle, text: mhText, left: null, right: mhCharac },
  gujarat: { title: gujTitle, text: gujText, left: null, right: gujCharac },
  punjab: { title: punjabTitle, text: punjabText, left: punjabLeft, right: punjabRight },
  andhra: { title: andhraTitle, text: andhraText, left: andhraCharac, right: null },
  karnataka: { title: karnatakaTitle, text: karnatakaText, left: karnatakaCharac, right: null },
};

export const FLOWERS = [flower1, flower2, flower3, flower4, flower5];
export const FARAL = [faral1, faral2, faral3, faral4, faral5, faral6, faral7, faral8, faral9];

export const SLOT = {
  main: slotMain,
  symbols: {
    "energy-64": slotEnergy,
    "staff-64": slotStaff,
    "cash-64": slotCash,
    "build-64": slotBuild,
    "goods-64": slotGoods,
    "gold-64": slotGold,
  },
};
